export default __webpack_public_path__ + "assets/images/fa0bb9d1ee915fdec7fdf0aaa727d399.svg";